import MuiAlert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import { useEffect, useState } from "react";
import React from "react";
import { useDispatch, useSelector } from "react-redux";

import {
	getAllCompanies,
	getAllSettingsTypes,
} from "../../../../../export/gat-admin";
import { factories } from "../../constants/factories";
import { OneCompany, OneCompanyWithSearchField } from "../../store/gat-admin-slice-types"

const MAXIMUM_ALLOWED_RETRY = 2; // Retry two additional time

const useManageFactoriesController = () => {
	const factoriesFromAPI = useSelector(
		(state: any) => state.gatAdminConfiguration.allCompanies
	);
	const companiesLoadingStatus = useSelector(
		(state: any) => state.gatAdminConfiguration.getAllCompanies.status
	);
	const companiesLoadingError = useSelector(
		(state: any) => state.gatAdminConfiguration.getAllCompanies.errorMessage
	);
	const creatingNewCompany = useSelector(
		(state: any) => state.gatAdminConfiguration.creatingNewCompany
	);

	const editUserRoleToDemoResetRoleStatus = useSelector(
		(state: any) => state.gatAdminConfiguration.updateUserRoleToDemoResetRole.status
	);

	const openSetUpDemoOwnerDialog = useSelector(
        (state: any) => state.gatAdminConfiguration.openSetUpDemoOwnerDialog
    );

	const roles = useSelector((state: any) => state.user.userData.userRoles);
	const dispatch = useDispatch();
	const [retried, setRetried] = useState(0);

	const [filteredCompanies, setFilteredCompanies] = useState([]);
	const [allCompanies, setAllCompanies] = useState<OneCompany[] | any>([]);
	const [searchQuery, setSearchQuery] = useState("");
	const [setupDemoOwnerCompanyObj, setStateDemoOwnerCompanyObj] = useState({})

	// Boeing related dummy data
	const [isBoeing, setIsBoeing] = useState(false);

	useEffect(() => {
		if (roles.includes("GATAdmin")) {
			if (factoriesFromAPI.length > 0) {
				const sortedFactoriesById = [...factoriesFromAPI];
				sortedFactoriesById.sort((a, b) => {
					return -(a.id - b.id); // Latest id first
				});
				setAllCompanies(sortedFactoriesById);
			}
		} else {
			setIsBoeing(true);
			setAllCompanies(factories);
		}
	}, [roles, factoriesFromAPI]);

	useEffect(() => {
		if (editUserRoleToDemoResetRoleStatus === "fulfilled") {
			dispatch(getAllCompanies());
		}
	}, [editUserRoleToDemoResetRoleStatus, dispatch]);

	useEffect(() => {
		try {
			if (searchQuery === "") {
				setFilteredCompanies(allCompanies);
			} else {

				const filteredCompanies = allCompanies.filter((company: any) => {
					const companyName = company.name.toLowerCase().includes(searchQuery.toLowerCase())
					const locations = company.locationCount.toString().includes(searchQuery.toLowerCase())
					const users = company.userCount.toString().includes(searchQuery.toLowerCase())
					const workers = company.workerCount.toString().includes(searchQuery.toLowerCase())
					const createdBy = company.createdBy.toLowerCase().includes(searchQuery.toLowerCase())
					const updatedBy = company.updatedBy.toLowerCase().includes(searchQuery.toLowerCase())

					return companyName ||
						locations ||
						users ||
						workers ||
						createdBy ||
						updatedBy
				})
				setFilteredCompanies(filteredCompanies ?? []);
			}
			
		} catch (e) {
			// Do nothing
		}
	}, [allCompanies, searchQuery]);

	const getAllCompaniesErrorAlert = (
		<Snackbar
			open={
				companiesLoadingStatus === "error" && retried < MAXIMUM_ALLOWED_RETRY
			}
			autoHideDuration={3000}
			onClose={() => {
				if (retried < MAXIMUM_ALLOWED_RETRY) {
					dispatch(getAllCompanies());
					setRetried((prevState) => prevState + 1);
				}
			}}
			anchorOrigin={{ vertical: "top", horizontal: "center" }}
		>
			<MuiAlert elevation={6} variant='filled' severity='error'>
				{companiesLoadingError ?? "An Error Occurred. Please try again."}
			</MuiAlert>
		</Snackbar>
	);
	useEffect(() => {
		if (roles.includes("GATAdmin")) {
			dispatch(getAllCompanies());
			dispatch(getAllSettingsTypes());
		}
	}, [dispatch, roles]);

	return [
		{
			allCompanies,
			companiesLoadingStatus,
			companiesLoadingError,
			filteredCompanies,
			isBoeing,
			searchQuery,
			creatingNewCompany,
			setupDemoOwnerCompanyObj,
			editUserRoleToDemoResetRoleStatus,
			openSetUpDemoOwnerDialog
		},
		{
			getAllCompaniesErrorAlert,
			setSearchQuery,
			setStateDemoOwnerCompanyObj
		},
	];
};

export default useManageFactoriesController;
